// TYPE ELITE — Searchable preset gradient library.
// Each preset is a real editable gradient (2-6 stops). Load populates editable stops.
export const GRADIENT_PRESETS = [
  // Metallic / Chrome
  { id: 'gp-chrome-silver', cat: 'Metallic', name: 'Silver Chrome', type: 'Linear', angle: 90, stops: [
    { color: '#F5F5F5', pos: 0, opacity: 100 }, { color: '#B0B0B0', pos: 35, opacity: 100 },
    { color: '#5A5A5A', pos: 65, opacity: 100 }, { color: '#E8E8E8', pos: 100, opacity: 100 } ] },
  { id: 'gp-chrome-gold', cat: 'Metallic', name: 'Polished Gold', type: 'Linear', angle: 90, stops: [
    { color: '#FFF3B0', pos: 0, opacity: 100 }, { color: '#D4AF37', pos: 40, opacity: 100 },
    { color: '#8A6D3B', pos: 70, opacity: 100 }, { color: '#F1E4C6', pos: 100, opacity: 100 } ] },
  { id: 'gp-chrome-rose', cat: 'Metallic', name: 'Rose Gold', type: 'Linear', angle: 90, stops: [
    { color: '#F7CAC9', pos: 0, opacity: 100 }, { color: '#EAB8A6', pos: 45, opacity: 100 },
    { color: '#B76E79', pos: 100, opacity: 100 } ] },
  { id: 'gp-chrome-copper', cat: 'Metallic', name: 'Copper Shine', type: 'Linear', angle: 90, stops: [
    { color: '#F4E1B7', pos: 0, opacity: 100 }, { color: '#DDA15E', pos: 45, opacity: 100 },
    { color: '#B87333', pos: 100, opacity: 100 } ] },
  { id: 'gp-chrome-mirror', cat: 'Metallic', name: 'Mirror Steel', type: 'Linear', angle: 180, stops: [
    { color: '#FFFFFF', pos: 0, opacity: 100 }, { color: '#9CA3AF', pos: 50, opacity: 100 },
    { color: '#1F2937', pos: 100, opacity: 100 } ] },
  { id: 'gp-chrome-titanium', cat: 'Metallic', name: 'Titanium', type: 'Linear', angle: 90, stops: [
    { color: '#D3D3D3', pos: 0, opacity: 100 }, { color: '#8B9DA4', pos: 50, opacity: 100 },
    { color: '#0F1517', pos: 100, opacity: 100 } ] },

  // Pink family
  { id: 'gp-pink-bubblegum', cat: 'Pink', name: 'Bubblegum Pop', type: 'Linear', angle: 90, stops: [
    { color: '#FFB6EE', pos: 0, opacity: 100 }, { color: '#FF6EC7', pos: 100, opacity: 100 } ] },
  { id: 'gp-pink-hotmagenta', cat: 'Pink', name: 'Hot Magenta', type: 'Linear', angle: 45, stops: [
    { color: '#FF10F0', pos: 0, opacity: 100 }, { color: '#7C3AED', pos: 100, opacity: 100 } ] },
  { id: 'gp-pink-blush', cat: 'Pink', name: 'Blush Dream', type: 'Linear', angle: 90, stops: [
    { color: '#FADADD', pos: 0, opacity: 100 }, { color: '#F1C6C7', pos: 100, opacity: 100 } ] },
  { id: 'gp-pink-berry', cat: 'Pink', name: 'Berry Splash', type: 'Linear', angle: 135, stops: [
    { color: '#FF3EA5', pos: 0, opacity: 100 }, { color: '#8B0044', pos: 100, opacity: 100 } ] },

  // Rainbow
  { id: 'gp-rainbow-classic', cat: 'Rainbow', name: 'Classic Rainbow', type: 'Linear', angle: 90, stops: [
    { color: '#FF0000', pos: 0, opacity: 100 }, { color: '#FF9E00', pos: 20, opacity: 100 },
    { color: '#FFEA00', pos: 40, opacity: 100 }, { color: '#00E676', pos: 60, opacity: 100 },
    { color: '#4361EE', pos: 80, opacity: 100 }, { color: '#7C3AED', pos: 100, opacity: 100 } ] },
  { id: 'gp-rainbow-pastel', cat: 'Rainbow', name: 'Pastel Rainbow', type: 'Linear', angle: 90, stops: [
    { color: '#FFB6C1', pos: 0, opacity: 100 }, { color: '#FFD8B1', pos: 25, opacity: 100 },
    { color: '#FDE68A', pos: 50, opacity: 100 }, { color: '#BBF7D0', pos: 75, opacity: 100 },
    { color: '#C4B5FD', pos: 100, opacity: 100 } ] },
  { id: 'gp-rainbow-tri', cat: 'Rainbow', name: 'Pink Gold Purple', type: 'Linear', angle: 90, stops: [
    { color: '#FF6EC7', pos: 0, opacity: 100 }, { color: '#D4AF37', pos: 50, opacity: 100 },
    { color: '#7C3AED', pos: 100, opacity: 100 } ] },

  // Neon
  { id: 'gp-neon-miami', cat: 'Neon', name: 'Miami Neon', type: 'Linear', angle: 90, stops: [
    { color: '#FF10F0', pos: 0, opacity: 100 }, { color: '#00E5FF', pos: 100, opacity: 100 } ] },
  { id: 'gp-neon-toxic', cat: 'Neon', name: 'Toxic Slime', type: 'Linear', angle: 45, stops: [
    { color: '#B7FF00', pos: 0, opacity: 100 }, { color: '#00FF66', pos: 100, opacity: 100 } ] },
  { id: 'gp-neon-cyber', cat: 'Neon', name: 'Cyber Grid', type: 'Linear', angle: 90, stops: [
    { color: '#FF0080', pos: 0, opacity: 100 }, { color: '#7C4DFF', pos: 50, opacity: 100 },
    { color: '#00FFFF', pos: 100, opacity: 100 } ] },

  // Pastel
  { id: 'gp-pastel-cotton', cat: 'Pastel', name: 'Cotton Candy', type: 'Linear', angle: 90, stops: [
    { color: '#FFC1CC', pos: 0, opacity: 100 }, { color: '#C7CEEA', pos: 100, opacity: 100 } ] },
  { id: 'gp-pastel-mint', cat: 'Pastel', name: 'Mint Bloom', type: 'Linear', angle: 90, stops: [
    { color: '#D6F5E3', pos: 0, opacity: 100 }, { color: '#C8E7FF', pos: 100, opacity: 100 } ] },
  { id: 'gp-pastel-peach', cat: 'Pastel', name: 'Peach Morning', type: 'Linear', angle: 90, stops: [
    { color: '#FFD8B1', pos: 0, opacity: 100 }, { color: '#F5C6C6', pos: 100, opacity: 100 } ] },

  // Jewel
  { id: 'gp-jewel-ruby', cat: 'Jewel', name: 'Ruby Depth', type: 'Linear', angle: 90, stops: [
    { color: '#FF6B6B', pos: 0, opacity: 100 }, { color: '#9B111E', pos: 100, opacity: 100 } ] },
  { id: 'gp-jewel-sapphire', cat: 'Jewel', name: 'Sapphire Deep', type: 'Linear', angle: 90, stops: [
    { color: '#4361EE', pos: 0, opacity: 100 }, { color: '#0B3D91', pos: 100, opacity: 100 } ] },
  { id: 'gp-jewel-emerald', cat: 'Jewel', name: 'Emerald Deep', type: 'Linear', angle: 90, stops: [
    { color: '#046307', pos: 0, opacity: 100 }, { color: '#0B6623', pos: 100, opacity: 100 } ] },
  { id: 'gp-jewel-amethyst', cat: 'Jewel', name: 'Amethyst', type: 'Linear', angle: 90, stops: [
    { color: '#C4B5FD', pos: 0, opacity: 100 }, { color: '#4B0082', pos: 100, opacity: 100 } ] },

  // Neutral / Monochrome
  { id: 'gp-neutral-ink', cat: 'Neutral & Mono', name: 'Ink Fade', type: 'Linear', angle: 90, stops: [
    { color: '#0F0F10', pos: 0, opacity: 100 }, { color: '#A1A1AA', pos: 100, opacity: 100 } ] },
  { id: 'gp-neutral-cream', cat: 'Neutral & Mono', name: 'Cream Whisper', type: 'Linear', angle: 90, stops: [
    { color: '#FDFBF7', pos: 0, opacity: 100 }, { color: '#C8BFA8', pos: 100, opacity: 100 } ] },
  { id: 'gp-neutral-charcoal', cat: 'Neutral & Mono', name: 'Charcoal Gunmetal', type: 'Linear', angle: 90, stops: [
    { color: '#000000', pos: 0, opacity: 100 }, { color: '#4C4C50', pos: 100, opacity: 100 } ] },

  // Sunset / Tropical
  { id: 'gp-sunset-blaze', cat: 'Sunset & Tropical', name: 'Sunset Blaze', type: 'Linear', angle: 90, stops: [
    { color: '#FF3D00', pos: 0, opacity: 100 }, { color: '#FF9E00', pos: 50, opacity: 100 },
    { color: '#FFC300', pos: 100, opacity: 100 } ] },
  { id: 'gp-sunset-miami', cat: 'Sunset & Tropical', name: 'Miami Sunset', type: 'Linear', angle: 90, stops: [
    { color: '#FF6B6B', pos: 0, opacity: 100 }, { color: '#FFA07A', pos: 40, opacity: 100 },
    { color: '#4361EE', pos: 100, opacity: 100 } ] },
  { id: 'gp-tropical-beach', cat: 'Sunset & Tropical', name: 'Tropical Beach', type: 'Linear', angle: 90, stops: [
    { color: '#00B4D8', pos: 0, opacity: 100 }, { color: '#48CAE4', pos: 50, opacity: 100 },
    { color: '#F9C784', pos: 100, opacity: 100 } ] },

  // Holographic
  { id: 'gp-holo-classic', cat: 'Holographic', name: 'Holo Foil', type: 'Linear', angle: 90, stops: [
    { color: '#F5B7FF', pos: 0, opacity: 100 }, { color: '#B7DBFF', pos: 33, opacity: 100 },
    { color: '#B7FFC5', pos: 66, opacity: 100 }, { color: '#FFF6B7', pos: 100, opacity: 100 } ] },
  { id: 'gp-holo-iridescent', cat: 'Holographic', name: 'Iridescent Shift', type: 'Linear', angle: 45, stops: [
    { color: '#FF71CE', pos: 0, opacity: 100 }, { color: '#B967FF', pos: 33, opacity: 100 },
    { color: '#01CDFE', pos: 66, opacity: 100 }, { color: '#05FFA1', pos: 100, opacity: 100 } ] },

  // Halloween
  { id: 'gp-hw-classic', cat: 'Halloween', name: 'Halloween Classic', type: 'Linear', angle: 90, stops: [
    { color: '#FF6B00', pos: 0, opacity: 100 }, { color: '#0A0A0A', pos: 100, opacity: 100 } ] },
  { id: 'gp-hw-witchy', cat: 'Halloween', name: 'Witchy Purple', type: 'Linear', angle: 90, stops: [
    { color: '#8000FF', pos: 0, opacity: 100 }, { color: '#0A0A0A', pos: 100, opacity: 100 } ] },
  { id: 'gp-hw-bloodmoon', cat: 'Halloween', name: 'Blood Moon', type: 'Radial', angle: 0, stops: [
    { color: '#FF6B00', pos: 0, opacity: 100 }, { color: '#8B0000', pos: 60, opacity: 100 },
    { color: '#0A0A0A', pos: 100, opacity: 100 } ] },
  { id: 'gp-hw-slime', cat: 'Halloween', name: 'Toxic Slime', type: 'Linear', angle: 90, stops: [
    { color: '#00FF66', pos: 0, opacity: 100 }, { color: '#7000FF', pos: 100, opacity: 100 } ] },

  // Christmas
  { id: 'gp-xm-traditional', cat: 'Christmas', name: 'Traditional Christmas', type: 'Linear', angle: 90, stops: [
    { color: '#B71C1C', pos: 0, opacity: 100 }, { color: '#0B6623', pos: 100, opacity: 100 } ] },
  { id: 'gp-xm-frost', cat: 'Christmas', name: 'Christmas Frost', type: 'Linear', angle: 180, stops: [
    { color: '#FFFFFF', pos: 0, opacity: 100 }, { color: '#3B82F6', pos: 100, opacity: 100 } ] },
  { id: 'gp-xm-goldred', cat: 'Christmas', name: 'Red & Gold', type: 'Linear', angle: 90, stops: [
    { color: '#B71C1C', pos: 0, opacity: 100 }, { color: '#FFD700', pos: 100, opacity: 100 } ] },

  // Valentine
  { id: 'gp-vd-classic', cat: 'Valentine', name: 'Classic Love', type: 'Linear', angle: 90, stops: [
    { color: '#FF3366', pos: 0, opacity: 100 }, { color: '#FFB6C1', pos: 100, opacity: 100 } ] },
  { id: 'gp-vd-romance', cat: 'Valentine', name: 'Moody Romance', type: 'Linear', angle: 90, stops: [
    { color: '#8B0000', pos: 0, opacity: 100 }, { color: '#F4C2C2', pos: 100, opacity: 100 } ] },
  { id: 'gp-vd-cupid', cat: 'Valentine', name: 'Cupid Pastel', type: 'Linear', angle: 90, stops: [
    { color: '#FFC1CC', pos: 0, opacity: 100 }, { color: '#C08497', pos: 100, opacity: 100 } ] },

  // Easter
  { id: 'gp-es-pastel', cat: 'Easter', name: 'Easter Pastel', type: 'Linear', angle: 90, stops: [
    { color: '#FBCFE8', pos: 0, opacity: 100 }, { color: '#BAE6FD', pos: 50, opacity: 100 },
    { color: '#BBF7D0', pos: 100, opacity: 100 } ] },
  { id: 'gp-es-meadow', cat: 'Easter', name: 'Bunny Meadow', type: 'Linear', angle: 90, stops: [
    { color: '#F4E285', pos: 0, opacity: 100 }, { color: '#A7D8F5', pos: 100, opacity: 100 } ] },

  // Seasons
  { id: 'gp-season-spring', cat: 'Seasons', name: 'Spring Bloom', type: 'Linear', angle: 90, stops: [
    { color: '#BBF7D0', pos: 0, opacity: 100 }, { color: '#FBCFE8', pos: 100, opacity: 100 } ] },
  { id: 'gp-season-summer', cat: 'Seasons', name: 'Summer Sun', type: 'Linear', angle: 90, stops: [
    { color: '#FDE68A', pos: 0, opacity: 100 }, { color: '#FF6B6B', pos: 100, opacity: 100 } ] },
  { id: 'gp-season-autumn', cat: 'Seasons', name: 'Autumn Warmth', type: 'Linear', angle: 90, stops: [
    { color: '#D97706', pos: 0, opacity: 100 }, { color: '#7C2D12', pos: 100, opacity: 100 } ] },
  { id: 'gp-season-winter', cat: 'Seasons', name: 'Winter Ice', type: 'Linear', angle: 90, stops: [
    { color: '#F3F4F6', pos: 0, opacity: 100 }, { color: '#3B82F6', pos: 100, opacity: 100 } ] },

  // Milestone / Life event
  { id: 'gp-life-birthday', cat: 'Milestones', name: 'Birthday Confetti', type: 'Linear', angle: 90, stops: [
    { color: '#FF3EA5', pos: 0, opacity: 100 }, { color: '#FFC93C', pos: 50, opacity: 100 },
    { color: '#6EC1E4', pos: 100, opacity: 100 } ] },
  { id: 'gp-life-baby-boy', cat: 'Milestones', name: 'Baby Boy Blue', type: 'Linear', angle: 90, stops: [
    { color: '#B2E4F7', pos: 0, opacity: 100 }, { color: '#A7D8F5', pos: 100, opacity: 100 } ] },
  { id: 'gp-life-baby-girl', cat: 'Milestones', name: 'Baby Girl Pink', type: 'Linear', angle: 90, stops: [
    { color: '#FFDEE9', pos: 0, opacity: 100 }, { color: '#FFC0CB', pos: 100, opacity: 100 } ] },
  { id: 'gp-life-wedding', cat: 'Milestones', name: 'Wedding Blush', type: 'Linear', angle: 90, stops: [
    { color: '#FADADD', pos: 0, opacity: 100 }, { color: '#D4AF37', pos: 100, opacity: 100 } ] },
  { id: 'gp-life-graduation', cat: 'Milestones', name: 'Gold Graduation', type: 'Linear', angle: 90, stops: [
    { color: '#D4AF37', pos: 0, opacity: 100 }, { color: '#0B0B0B', pos: 100, opacity: 100 } ] },

  // Additional variety to reach 60+ presets
  { id: 'gp-chrome-blackchrome', cat: 'Metallic', name: 'Black Chrome', type: 'Linear', angle: 90, stops: [
    { color: '#3C3C3C', pos: 0, opacity: 100 }, { color: '#0A0A0A', pos: 50, opacity: 100 }, { color: '#5A5A5A', pos: 100, opacity: 100 } ] },
  { id: 'gp-pink-neon', cat: 'Pink', name: 'Neon Hot Pink', type: 'Linear', angle: 90, stops: [
    { color: '#FF10F0', pos: 0, opacity: 100 }, { color: '#FF3EA5', pos: 100, opacity: 100 } ] },
  { id: 'gp-rainbow-fire', cat: 'Rainbow', name: 'Fire Rainbow', type: 'Linear', angle: 90, stops: [
    { color: '#FFEA00', pos: 0, opacity: 100 }, { color: '#FF6B00', pos: 50, opacity: 100 }, { color: '#B71C1C', pos: 100, opacity: 100 } ] },
  { id: 'gp-neon-electric', cat: 'Neon', name: 'Electric Lime', type: 'Linear', angle: 90, stops: [
    { color: '#B7FF00', pos: 0, opacity: 100 }, { color: '#00FFEA', pos: 100, opacity: 100 } ] },
  { id: 'gp-pastel-lavender', cat: 'Pastel', name: 'Lavender Whisper', type: 'Linear', angle: 90, stops: [
    { color: '#E6B6FF', pos: 0, opacity: 100 }, { color: '#F3E8FF', pos: 100, opacity: 100 } ] },
  { id: 'gp-jewel-topaz', cat: 'Jewel', name: 'Topaz', type: 'Linear', angle: 90, stops: [
    { color: '#FFC300', pos: 0, opacity: 100 }, { color: '#B45309', pos: 100, opacity: 100 } ] },
  { id: 'gp-sunset-tequila', cat: 'Sunset & Tropical', name: 'Tequila Sunrise', type: 'Linear', angle: 90, stops: [
    { color: '#FF6B00', pos: 0, opacity: 100 }, { color: '#F94144', pos: 100, opacity: 100 } ] },
  { id: 'gp-holo-mermaid', cat: 'Holographic', name: 'Mermaid Shimmer', type: 'Linear', angle: 45, stops: [
    { color: '#48CAE4', pos: 0, opacity: 100 }, { color: '#B7FFC5', pos: 50, opacity: 100 }, { color: '#F5B7FF', pos: 100, opacity: 100 } ] },
  { id: 'gp-hw-poison', cat: 'Halloween', name: 'Poison Green', type: 'Linear', angle: 180, stops: [
    { color: '#0A0A0A', pos: 0, opacity: 100 }, { color: '#00FF66', pos: 100, opacity: 100 } ] },
  { id: 'gp-xm-forest', cat: 'Christmas', name: 'Forest Green', type: 'Linear', angle: 90, stops: [
    { color: '#0B6623', pos: 0, opacity: 100 }, { color: '#004225', pos: 100, opacity: 100 } ] },
  { id: 'gp-neutral-slate', cat: 'Neutral & Mono', name: 'Slate Fade', type: 'Linear', angle: 90, stops: [
    { color: '#1F2937', pos: 0, opacity: 100 }, { color: '#9CA3AF', pos: 100, opacity: 100 } ] },
];

export const GRADIENT_PRESET_CATEGORIES = Array.from(new Set(GRADIENT_PRESETS.map(p => p.cat)));
